import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { ICONS } from 'Components/utils/icon/icons';
import type { IconName } from 'Components/frameworks/icon/Icon';
import { Icon } from 'Components/frameworks/icon/Icon';
import { Scrollable } from 'Components/frameworks/scrollable/Scrollable';
import type { ProductMustTryCardProps } from 'Components/widgets/product-must-try-card/ProductMustTryCard';
import { ProductMustTryCard } from 'Components/widgets/product-must-try-card/ProductMustTryCard';
type Props = {
  className?: string;
  isFrench?: boolean;
  items: Array<ProductMustTryCardProps>;
  productIconName: IconName;
  scrollBackwardLabel?: string;
  scrollForwardLabel?: string;
};
export const ProductMustTryNarrow = ({
  className,
  isFrench,
  items = [],
  productIconName,
  scrollBackwardLabel,
  scrollForwardLabel,
}: Props) => (
  <div className={classnames('relative isolate', className)}>
    <div className="absolute inset-0 h-[390px] bg-lightSand p-20 text-center">
      <div className="absolute start-0 top-0 pt-10 opacity-25">
        <Icon className="text-sand" isNotSquare name={productIconName} width="8.75rem" />
      </div>
      <Icon
        className="text-black"
        name={isFrench ? ICONS.MUST_TRY_EXPERIENCES_FR : ICONS.MUST_TRY_EXPERIENCES}
        width={isFrench ? '12.5rem' : '10rem'}
      />
    </div>
    <Scrollable
      backwardLabel={scrollBackwardLabel}
      className="pt-95"
      forwardLabel={scrollForwardLabel}
      navPosition="center"
    >
      <div className="flex px-10">
        {items.map(({ description, id, imageSrc, onClick, seeMoreLabel, title }) => (
          <div key={id} className="m-10 w-280 flex-none">
            <ProductMustTryCard
              description={description}
              id={id}
              imageSrc={imageSrc}
              onClick={onClick}
              seeMoreLabel={seeMoreLabel}
              title={title}
            />
          </div>
        ))}
        <div className="pr-10" />
      </div>
    </Scrollable>
  </div>
);
